import SearchPage from "../../features/pages/SearchPage"
import galleryApiService from "../../services/galleryApiService"

const Search = ({ results, searchTerm, filters }) => {
  return (
    <SearchPage results={results} searchTerm={searchTerm} filters={filters} />
  )
}

const firstValue = (v) => (Array.isArray(v) ? v[0] : v)

export const getServerSideProps = async (ctx) => {
  const search = firstValue(ctx.query.search) || ""

  const response = await galleryApiService.search({
    ...ctx.query,
    search,
    withGalleryFeatured: true,
  })

  const filterResponse = await galleryApiService.artworksfilters()

  return {
    props: {
      results: response.data,
      searchTerm: search,
      filters: filterResponse.data,
    },
  }
}

export default Search
